module.exports = "/packs/images/homepage/activity/extreme_desktop~d679bd2fe335d5f7c9b86b8b2b3f6dd8.jpg";